import { render, staticRenderFns } from "./FndMenuQuery.vue?vue&type=template&id=33c0d036&"
import script from "./FndMenuQuery.vue?vue&type=script&lang=js&"
export * from "./FndMenuQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports